import * as React from "react";
import Component from "../../AbstractComponent";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import Button from '@material-ui/core/Button';

export default class CompanyDetailsReadonly extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}

	public getReadonlyReason = (company: CompanyInterface) => {
		if (company?.removed) {
			return this.trans("company-readonly/removed");
		}
	}
	
  public render() {
		const company: CompanyInterface = this.props.company;
		
		return (
			<div className="charge-details-readonly">
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
					<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
						{this.trans("label-company")}
					</div>
				</div>
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
					<div className="counterparty">
						{`${company?.displayName}`}
					</div>
				</div>
				<table>
					{
						company?.generalContact && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("label/agency-general-contact")}: `}
								</td>
								<td className="align-left">
									<div className="margin-wrapper">
										<div 
											className="link-to-entity" 
											onClick={() => this.redirect(`/app/person/update/${company.generalContactId}/`)}
										>
											{`${company?.generalContact?.displayName}`}
										</div>
									</div>
								</td>
							</tr>
						)
					}
					{
						company?.phone && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("phone")}: `}
								</td>
								<td className="align-left">
									{company?.phone}
								</td>
							</tr>
						)
					}
					{
						company?.address && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("label-address")}: `}
								</td>
								<td className="align-left">
									{company?.address?.formattedAddress}
								</td>
							</tr>
						)
					}
					{
						company?.mainBankAccountId && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("label-bank-account-id")}: `}
								</td>
								<td className="align-left">
									{company?.mainBankAccountId}
								</td>
							</tr>
						)
					}
				</table>
				{
					company?.isReadonly && this.props.mainCardPresentation &&
						<div className="readonly-reason" style={{flexDirection: "column"}}>
							<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
								<div
									className="list-label readonly"
									style={{
										marginRight: "5px",
										maxWidth: "max-content"
									}}
								>
									{company?.isReadonly && this.trans("label-readonly")}
								</div>
								<div>{this.getReadonlyReason(company)}</div>
							</div>
						</div>
				}
				{
					!this.props.mainCardPresentation && (
						<div style={{marginTop: "10px", display: "flex", justifyContent: "flex-start"}}>
							<Button 
								variant="outlined"
								color="primary"
								onClick={() => this.redirect(`/app/company/update/${company?.id}`)}
							>
								{this.trans("button-open")}
							</Button>
						</div>
					)
				}
			</div>
		);
  }
}
